import { Component } from '@angular/core';
import { FirestoreService } from '../../services/firestore.service';

@Component({
  selector: 'app-test-firestore',
  templateUrl: './test-firestore.component.html',
})
export class TestFirestoreComponent {
  //items$ = this.firestore.getTestItems();
  //newItem = '';

  constructor(private firestore: FirestoreService) {}

  // addItem() {
  //   if (this.newItem.trim()) {
  //     this.firestore.addTestItem(this.newItem.trim());
  //     this.newItem = '';
  //   }
  // }
}
